<script lang="ts" setup>   
    import '../../css/choice.css';
    import {onMounted,reactive,watch} from 'vue';
    import {GetMedPatientEducation,IMedInformationInput,IMedPatientEducation,medInformationType,educationMonographType,
        reportPage1Rows,reportPage2Rows,no_drug_information,buildDoubleColumnReport,errorReturnMessage} from '../lib/Models/InteractionModel'; 

    const formData = reactive <
    {   
        medRetrieved: boolean,
        educationList? : IMedPatientEducation[],
        noData: boolean,
        medErrorMessage? : string
    }>
    ({     
        medRetrieved : false,
        noData: true,
        medErrorMessage: ""
    });
    onMounted(() => { 
    });
    const props = withDefaults(defineProps<
        {
            showDialog: boolean,
            patientID: number,
            prescriptionID?: number,
            medicationID?: number,
            drugName?: string,
            displayHeight? : number
        }>(),
        {
            showDialog: false,
            patientID: 0,
            prescriptionID: 0,
            medicationID: 0 ,
            drugName: "",
            displayHeight : 350
        });

    watch(() => props.showDialog, (newShow,oldShow) => { 
        if ((newShow) && (newShow !== oldShow) && (!formData.medRetrieved)) { 
            getPatientEducation();
        }
    });

    const emit=defineEmits(["updateModalPatientEducation"]);  

    async function getPatientEducation() : Promise<void> {   
        const medInputs : IMedInformationInput = {InformationType: medInformationType.PatientEducation,PatientID: props.patientID, PrescriptionID: props.prescriptionID, MedID: props.medicationID};
        const respGet = await GetMedPatientEducation(medInputs);  
        if (!respGet.success) {  
            formData.medErrorMessage = respGet.error?.error ?? errorReturnMessage.patientEducation; 
            return;
        } 
        formData.noData = (respGet.success.educationList.length === 0 ? true : false);
        formData.medRetrieved = true; 
        formData.educationList = respGet.success.educationList; 
        if (formData.educationList.length > 0) { 
            const reportingData = formData.educationList.map(item => (item.monographType === educationMonographType.Break ? "<br/>" : "<div>" + item.monograph + "</div>"));
            const report_title = "Patient Education";
            const report_data = buildDoubleColumnReport(report_title,props.drugName,reportPage1Rows,reportPage2Rows,reportingData);  
            emit('updateModalPatientEducation',true,report_data);  
        } 
    } 
</script>

<template> 
    <div class="row pt-2"> 
        <div v-if="formData.medErrorMessage" class="col"> 
            {{ formData.medErrorMessage }}
        </div>
        <div v-if="!formData.medErrorMessage" class="col"> 
            <div class="row"> 
                <div class="fw-bold fs-6 text-isalus-primary pb-2 ">
                    Patient Education
                </div>
            </div>
            <div class="row"> 
                <div class="col skinnyscroll " :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': (props.displayHeight + 'px')}"> 
                    <div v-if="formData.noData" class="text-muted"> 
                       {{ no_drug_information }}
                    </div>
                    <div v-if="!formData.noData" v-for="educationRecord in formData.educationList"> 
                        <div class="text-muted"> 
                            <span v-if="educationRecord.monographType !== educationMonographType.Break">
                                {{educationRecord.monograph}}
                            </span>
                            <br v-if="educationRecord.monographType === educationMonographType.Break" />
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>